export function formatDobInput(raw) {
  const digits = String(raw ?? '').replace(/\D/g, '').slice(0, 8)
  if (digits.length <= 2) return digits
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`
}

export function toDobDisplayValue(value) {
  if (value == null || String(value).trim() === '') return ''
  const text = String(value).trim()
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(text)) return text
  const iso = text.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (iso) {
    const [, year, month, day] = iso
    return `${day}/${month}/${year}`
  }
  const parsed = new Date(text)
  if (Number.isNaN(parsed.getTime())) return text
  const day = String(parsed.getDate()).padStart(2, '0')
  const month = String(parsed.getMonth() + 1).padStart(2, '0')
  const year = parsed.getFullYear()
  return `${day}/${month}/${year}`
}

export function toDobApiValue(displayValue) {
  const text = String(displayValue ?? '').trim()
  if (!text) return null
  const match = text.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
  if (!match) return null
  const [, day, month, year] = match
  const dayNum = Number(day)
  const monthNum = Number(month)
  const yearNum = Number(year)
  if (monthNum < 1 || monthNum > 12 || dayNum < 1 || dayNum > 31 || yearNum < 1900 || yearNum > 2100) return null
  const parsed = new Date(yearNum, monthNum - 1, dayNum)
  if (
    parsed.getFullYear() !== yearNum ||
    parsed.getMonth() !== monthNum - 1 ||
    parsed.getDate() !== dayNum
  ) return null
  return `${year}-${month}-${day}`
}

export function normalizeDobForCompare(value) {
  if (value == null || String(value).trim() === '') return ''
  return toDobApiValue(toDobDisplayValue(value)) ?? String(value).trim()
}

export function formatContactGender(value, t) {
  const raw = value == null || String(value).trim() === '' ? null : String(value).trim()
  if (!raw) return t('contacts.emptyValue')
  const normalized = raw.toLowerCase()
  const key = `contacts.genderValues.${normalized}`
  const translated = t(key)
  return translated === key ? raw : translated
}

export function formatContactDob(value, t) {
  const display = toDobDisplayValue(value)
  if (!display) return t('contacts.emptyValue')
  return display
}
